/**
 * Access to the desktop shell's auto-update bridge, exposed by
 * desktop/preload.js as `window.electronDesktop.updater`.
 *
 * The Electron main process downloads new versions in the background and emits
 * `update:downloaded` when one is ready. Every function here is a no-op in a
 * normal browser, so callers need no environment check of their own.
 */

function bridge() {
  return typeof window !== 'undefined' ? window.electronDesktop?.updater : undefined;
}

/** True when running inside the desktop shell with the updater available. */
export function hasUpdater() {
  return !!bridge();
}

/** Fires when a new version has finished downloading. Returns an unsubscribe fn. */
export function onUpdateDownloaded(cb) {
  const b = bridge();
  if (!b) return () => {};
  return b.onDownloaded((payload) => cb(payload?.version ?? null));
}

/**
 * Quit and install the downloaded update now; the app restarts on the new version.
 * Resolves false when the user chooses Stay at the shell's unsaved-changes prompt: the app
 * keeps running and the update installs on the next quit. An older shell resolves undefined.
 */
export async function installUpdate() {
  const b = bridge();
  if (!b) return undefined;
  try {
    return await b.install();
  } catch {
    // Quitting the app applies the update anyway.
    return undefined;
  }
}
